import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { combineLatest, of } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { customerConfig, MCustomer } from '@uxdf/direct-shared-lib';
import * as CoreActions from '@uxdf/direct-shared-lib/src/lib/login/core.actions';
import { BackendService } from '../services/backend.service';
import * as BannerTileActions from '../actions/actions-banner-tile';
import { BannerTileHelperService } from '../services/banner-tile-helper.service';
import { MBanner } from '../models/banner';
import { __config_layout } from '../reducers';

@Injectable()
export class EffectsBannerTile {
  getBanner$ = createEffect(() =>
    combineLatest([
      this.actions$.pipe(ofType(BannerTileActions.GetBannerTile)),
      this.store.pipe(select(customerConfig)),
      this.store.pipe(select(__config_layout))]
    ).pipe(
      filter(([, /* action */ customerConfigState, layout]) => !layout.isLoading),
      switchMap(([, customerConfigState, layout]) => {
        const config: MCustomer = customerConfigState.customerConfig;
        const size = layout.config.home_page_tiles.find(item => item.module === 'banner').size;

        return this.backendService.getBanner(config.default_store_code, config.scope.role, config.scope.segment).pipe(
          map((data: MBanner[]) => BannerTileActions.GetBannerTileSuccess({ banners: data, bannersSize: size })),
          catchError(error => {
            if (error && error.error !== undefined && (error.error.code === 40 || error.error.code === 42)) {
              return of(new CoreActions.DirectUserRoleHasBeenChanged());
            } else {
              return of(BannerTileActions.GetBannerTileError({ error: error.error.message }));
            }
          })
        );
      })
    )
  );

  getBannerError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(BannerTileActions.GetBannerTileError),
        map((action: any) => action.payload),
        map((message: string) => {
          this.bannerTileService.alertError('Banner error: ' + message);
        })
      ),
    { dispatch: false }
  );

  constructor(
    private readonly actions$: Actions,
    private readonly backendService: BackendService,
    private readonly store: Store<any>,
    private readonly bannerTileService: BannerTileHelperService
  ) {}
}
